module.exports = __webpack_public_path__ + "static/img/zyhh2.82c9f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/zyhh2.png
// module id = 1284
// module chunks = 0